import { fetchMergeStatusById, MERGE_FAILED, MergeResult } from "@/common/lib/api/visitMerges";
import { pollMergeStatus } from "./pollMergeStatus";

type Failure = Exclude<MergeResult, { ok: true }>;

/**
 * Outcomes that can hide an unmerge that committed: no answer, a 5xx other than MERGE_FAILED (the API answers a
 * bare 500 when the RPC outcome is unknown), "unmerge_unavailable", which the server also returns for a merge that is already unmerged, and
 * "visit_changed", which an unmerge of the same merge from another path (toast Undo, another tab) can cause.
 */
export const unmergeMayHaveWorked = (r: Failure) =>
    r.kind === "unknown" ||
    (r.kind === "error" && (r.status == null || r.status >= 500) && r.code !== MERGE_FAILED) ||
    (r.kind === "blocked" && (r.reason === "unmerge_unavailable" || r.reason === "visit_changed"));

/**
 * Asks the server before telling the vet an unmerge failed. A failed status request is retried. "merged" is
 * waited out unless the unmerge was refused: then the unmerge is not in flight and "merged" is the final
 * answer. Returns the "unmerged" status, or null when it never showed.
 */
export const confirmedUnmerged = (mergeId: string, failure: Failure) =>
    pollMergeStatus({
        fetch: () => fetchMergeStatusById(mergeId),
        want: "unmerged",
        waitWhileOther: failure.kind !== "blocked",
        retryOnError: true,
    });
